import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Grid,
  ImageList,
  ImageListItem,
  MenuItem,
  Typography,
} from "@mui/material";
import FilterSelect from "../../../../components/select/filterSelect";
import { useParams } from "react-router-dom";
import { ROOM_MEETING_TYPE } from "../../../../constants/enum";
import { useDispatch, useSelector } from "react-redux";
import { BookingMeetingRoomApi } from "../../../../api/booking-meeting-room/booking-meeting-room.api";
import { swalError } from "../../../../components/alert/swal";
import ClassroomCard from "./ClassroomCard";
import { ButtonOutlined } from "../../../../components/button/ButtonCustoms";
import ModalCustom from "../../../../components/modal/ModalCustom";
import { useTranslation } from "react-i18next";
import StepperCustom from "../../../../components/step/Stepper";
import { IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  CalendarPicker,
  LocalizationProvider,
  PickersDay,
} from "@mui/x-date-pickers";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import thLocale from "date-fns/locale/th";
import { dateToView } from "../../../../utils/date.utils";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import { RootState } from "../../../../store/store";

type Props = {
  formMeetingRoom: any;
  setFormMeetingRoom: any;
  roomMeetinDetail: any;
  room_meeting_type?: string;
}
export default function MeetingRoomDetail(props: Props) {
  const { t } = useTranslation();
  const base_api_img = useSelector((state: RootState) => state.api.image_api);

  const { formMeetingRoom, setFormMeetingRoom, roomMeetinDetail } = props;
  const { id } = useParams();
  const dispatch = useDispatch();

  const [meetingType, setMeetingType] = useState<any[]>([
    {
      id_meeting_type: ROOM_MEETING_TYPE.CLASS_ROOM,
      meeting_type_name: ROOM_MEETING_TYPE.CLASS_ROOM,
    },
    {
      id_meeting_type: ROOM_MEETING_TYPE.MEETING_ROOM,
      meeting_type_name: ROOM_MEETING_TYPE.MEETING_ROOM,
    },
  ]);

  const [roomMeeting, setRoomMeeting] = useState<any[]>([]);
  const [isModalRoomDetail, setIsModalRoomDetail] = useState<boolean>(false);
  const [dataModalRoomDetail, setDataModalRoomDetail] = useState<any>({});
  const [step, setStep] = useState<number>(0);

  //
  const dayOfWeekFormatter = (day: any) => {
    const days: any = {
      "จ.": "จันทร์",
      "อ.": "อังคาร",
      "พ.": "พุธ",
      "พฤ.": "พฤหัสบดี",
      "ศ.": "ศุกร์",
      "ส.": "เสาร์",
      "อา.": "อาทิตย์",
    };
    return days[day] || day;
  };
  const [data, setData] = useState<any[]>([]);
  const [date, setDate] = useState<any>(new Date());

  const getRoomMeetingByType = async (type: string) => {
    try {
      const res = await BookingMeetingRoomApi.getRoomMeetingByTypeList({
        room_meeting_type: type,
      });

      if (res.status < 300) {
        setRoomMeeting(res.data.data ?? []);
      }
    } catch (error) {
      console.log(error);
      swalError("เกิดข้อผิดพลาด");
    }
  };

  const getRoomMeetingDetailById = async (id_room_meeting: number) => {
    try {
      const res = await BookingMeetingRoomApi.getRoomMeetingDetailById(
        +id_room_meeting
      );

      if (res.status < 300) {
        setDataModalRoomDetail(res.data.data ?? []);
      }
    } catch (error) {
      console.log(error);
      swalError("เกิดข้อผิดพลาด");
    }
  };

  const allStep: any[] = useMemo(
    () => [
      { name: "ข้อมูลห้อง", isAccept: true, icon: null, disabled: false },
      {
        name: "ข้อมูลห้อง",
        isAccept: true,
        icon: null,
        disabled: false,
      },
    ],
    [t]
  );

  type RoomFile = {
    room_meeting_file_type: string;
    file_path: string;
  };

  type Room = {
    files?: RoomFile[];
  };

  type ImageSliderProps = {
    room: Room;
    base_api_img: string;
  };

  const ImageSlider: React.FC<ImageSliderProps> = ({ room, base_api_img }) => {
    const contentImages = useMemo(
      () =>
        room.files?.filter(
          (file) => file.room_meeting_file_type === "CONTENT"
        ) ?? [],
      [room.files]
    );

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
      if (currentIndex >= contentImages.length) {
        setCurrentIndex(0);
      }
    }, [contentImages.length, currentIndex]);

    if (!contentImages.length) return null;

    const length = contentImages.length;

    const handleNext = () => {
      setCurrentIndex((prev) => (prev + 1) % length);
    };

    const handlePrev = () => {
      setCurrentIndex((prev) => (prev - 1 + length) % length);
    };

    const prevIndex = (currentIndex - 1 + length) % length;
    const nextIndex = (currentIndex + 1) % length;

    return (
      <Box className="relative flex items-center justify-center w-full max-w-lg gap-2">
        <IconButton
          onClick={handlePrev}
          className="absolute left-2 z-10 bg-white shadow-md rounded-full"
          disabled={length <= 1}
        >
          <ArrowBackIos />
        </IconButton>

        {/* รูปซ้าย (เล็ก) แสดงเมื่อมีมากกว่า 1 รูป */}
        {length > 1 && (
          <img
            src={base_api_img + contentImages[prevIndex].file_path}
            alt="Room Content Previous"
            className="w-full h-24 object-cover rounded-lg opacity-70 hidden sm:block"
          />
        )}

        {/* รูปกลาง (ใหญ่) */}
        <img
          src={base_api_img + contentImages[currentIndex].file_path}
          alt="Room Content"
          className="w-full h-32 object-cover rounded-lg px-12"
        />

        {/* รูปขวา (เล็ก) แสดงเมื่อมีมากกว่า 2 รูป (เพื่อไม่ให้ซ้ำกับรูปซ้าย) */}
        {length > 2 && (
          <img
            src={base_api_img + contentImages[nextIndex].file_path}
            alt="Room Content Next"
            className="w-full h-24 object-cover rounded-lg opacity-70 hidden sm:block"
          />
        )}

        <IconButton
          onClick={handleNext}
          className="absolute right-2 z-10 bg-white shadow-md rounded-full"
          disabled={length <= 1}
        >
          <ArrowForwardIos />
        </IconButton>
      </Box>
    );
  };

  useEffect(() => {
    if (roomMeetinDetail.id_room_meeting) {
      getRoomMeetingDetailById(+roomMeetinDetail.id_room_meeting);
    }
  }, [roomMeetinDetail.id_room_meeting]);

  return (
    <section className="w-full mt-10">
      <ModalCustom
        maxWidth={1400}
        open={isModalRoomDetail}
        title={`รายละเอียด ${dataModalRoomDetail?.room_meeting_name}`}
        subTitle={""}
        onClose={() => {
          setIsModalRoomDetail(false);
          setDataModalRoomDetail({});
        }}
        component={
          <>
            <Box className="flex items-center justify-center mt-2">
              {/* Location */}
              <Box className="flex items-center overflow-hidden">
                <FmdGoodIcon className="mr-1" />
                <Typography
                  variant="body2"
                  className="text-gray-500 truncate w-40"
                >
                  {dataModalRoomDetail.room_meeting_location}
                </Typography>
              </Box>

              {/* Meeting Amount */}
              <Box className="flex items-center overflow-hidden">
                <AccountCircleIcon className="mr-1" />
                <Typography
                  variant="body2"
                  className="text-gray-500 truncate w-20"
                >
                  {dataModalRoomDetail.room_meeting_amount} คน
                </Typography>
              </Box>
            </Box>
            <section className="flex items-center justify-center">
              <StepperCustom
                sx={{ maxWidth: "500px" }}
                step={step}
                setStep={(num: number) => {
                  setStep(num);
                }}
                stepLabel={allStep}
                view={true}
              />
            </section>

            {step === 0 && (
              <>
                <section className="flex items-center justify-center">
                  <ImageSlider
                    base_api_img={base_api_img}
                    room={
                      dataModalRoomDetail ?? {
                        files: [],
                      }
                    }
                  />
                </section>

                <h2>อุปกรณ์ภายในห้อง</h2>

                {dataModalRoomDetail.equipment &&
                  dataModalRoomDetail.equipment.map(
                    (item: any, index: number) => (
                      <li key={`equipment-${item.id_equipment}`}>
                        {item.equipment_name}
                      </li>
                    )
                  )}
              </>
            )}

            {step === 1 && (
              <div style={{ width: "100%" }}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  locale={thLocale}
                >
                  <Box
                    sx={{
                      "& .MuiPickersDay-root": {
                        width: "200px",
                        height: "60px",
                        fontSize: "16px",
                      },
                      "& .MuiCalendarPicker-root": {
                        width: "100%",
                        height: "auto",
                        maxHeight: "none",
                      },
                      "& .MuiTypography-caption": {
                        width: "200px",
                        height: "60px",
                        fontSize: "16px",
                        fontWeight: "bold",
                      },
                      "& .MuiPickersCalendarHeader-label": {
                        fontSize: "18px",
                        fontWeight: "bold",
                      },
                      boxShadow: "0px 0px 8.8px 0px #00000026",
                      borderRadius: "16px",

                      gap: "20px",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    <CalendarPicker
                      date={date}
                      onChange={(newDate) => {
                        setDate(newDate);
                      }}
                      views={["day"]}
                      disableFuture={false}
                      reduceAnimations
                      renderDay={(day, selectedDates, pickersDayProps) => {
                        const a = data
                          ?.filter(
                            (item: any) =>
                              dateToView(item?.meeting_date) === dateToView(day)
                          )
                          ?.filter(
                            (item: any) => item?.status !== "NOT_START_YET"
                          )?.length;
                        const b = data
                          ?.filter(
                            (item: any) =>
                              dateToView(item?.meeting_date) === dateToView(day)
                          )
                          ?.filter(
                            (item: any) => item?.status === "NOT_START_YET"
                          )?.length;
                        console.log(a);
                        return (
                          <div style={{ position: "relative" }}>
                            <PickersDay
                              {...pickersDayProps}
                              sx={{
                                borderRadius: "10px",
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                display: "flex",
                                gap: "10px",
                              }}
                            >
                              {a > 0 && (
                                <div
                                  style={{
                                    backgroundColor: "#0F9F0C",
                                    color: "#fff",
                                    width: "30px",
                                    height: "30px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "50%",
                                  }}
                                >
                                  {a}
                                </div>
                              )}
                              {b > 0 && (
                                <div
                                  style={{
                                    backgroundColor: "#B54708",
                                    color: "#fff",
                                    width: "30px",
                                    height: "30px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "50%",
                                  }}
                                >
                                  {b}
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      }}
                      dayOfWeekFormatter={dayOfWeekFormatter}
                    />
                  </Box>
                </LocalizationProvider>

                <div>
                  <div className="my-4">
                    {data &&
                      data
                        ?.filter(
                          (item: any) =>
                            dateToView(item?.meeting_date) === dateToView(date)
                        )
                        .map((data: any, i: any) => {
                          console.log(data);
                          return (
                            <div
                              style={{
                                boxShadow: "0px 0px 8.8px 0px #00000026",
                                padding: "40px",
                                borderRadius: "16px",
                                display: "flex",
                                flexDirection: "column",
                                gap: "20px",
                                marginBottom: "20px",
                              }}
                            >
                              <div>
                                <Typography>
                                  {data?.meeting_room_name}
                                </Typography>
                                <Typography>
                                  หมวดหมู่ : {data?.meeting_type_name}
                                </Typography>
                                <Typography>
                                  วันที่ : {dateToView(data?.meeting_date)}
                                </Typography>
                                <Typography>
                                  เวลา : {data?.meeting_time_start} -{" "}
                                  {data?.meeting_time_end}
                                </Typography>
                                <Typography>
                                  <FmdGoodOutlinedIcon />
                                  {data?.meeting_room_location || "-"}
                                </Typography>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {data?.status === "NOT_START_YET" ? (
                                  <div
                                    style={{
                                      backgroundColor: "#FFFAEB",
                                      width: "100%",
                                      maxWidth: 250,
                                      minHeight: 30,
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      padding: "8px 8px",
                                      borderRadius: "16px",
                                      wordBreak: "break-word", // ป้องกันข้อความล้น
                                      whiteSpace: "normal", // ให้ข้อความขึ้นบรรทัดใหม่
                                    }}
                                  >
                                    <Typography sx={{ color: "#B54708" }}>
                                      {" "}
                                      ยังไม่ถึงกำหนดประชุม
                                    </Typography>
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      backgroundColor: "#ECFDF3",
                                      width: "100%",
                                      maxWidth: 250,
                                      minHeight: 30,
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      padding: "8px 8px",
                                      borderRadius: "16px",
                                      wordBreak: "break-word", // ป้องกันข้อความล้น
                                      whiteSpace: "normal", // ให้ข้อความขึ้นบรรทัดใหม่
                                    }}
                                  >
                                    <Typography sx={{ color: "#0F9F0C" }}>
                                      {" "}
                                      ดำเนินการเสร็จสิ้น
                                    </Typography>
                                  </div>
                                )}
                                {/* <OptionsButtonCustom
                                enableView
                                onViewClick={() => {
                                  if (data?.meeting_room_has_password === "1") {
                                    setForm(data);
                                    setOpen(true);
                                  } else {
                                    navigate(
                                      routeName.students.MeetingCaledarDetail.replace(
                                        ":id",
                                        data?.id_meeting_room
                                      )
                                    );
                                  }
                                }}
                              /> */}
                              </div>
                            </div>
                          );
                        })}
                  </div>
                </div>
              </div>
            )}

            <div className="mt-6 w-full flex justify-center gap-4 items-center col-span-2">
              <span>
                <ButtonOutlined
                  onClick={() => {
                    setIsModalRoomDetail(false);
                    setDataModalRoomDetail({});
                  }}
                  mode="del"
                  buttonName="ยกเลิก"
                />
              </span>
            </div>
          </>
        }
      />

      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <FilterSelect
            heading="ประเภทการประชุม"
            labelId="year-id"
            selectId="year-select-id"
            options={meetingType.map((item: any, index: number) => (
              <MenuItem value={item.id_meeting_type} key={index + 1}>
                {item.meeting_type_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                id_meeting_type: e.target.value,
              });
              getRoomMeetingByType(e.target.value);
            }}
            value={formMeetingRoom?.id_meeting_type || props.room_meeting_type || ""}
            disabled={id ? true : false}
          />
        </Grid>
      </Grid>

      <section className="w-full mt-10">
        <Grid container spacing={2}>
          {id && (
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{
                alignSelf: "end",
                border: "1px solid #e0e0e0", // light gray border
                borderRadius: "8px",
                padding: 2,
                backgroundColor: "#fff",
                boxShadow: 1,
              }}
            >
              <>
                {`รายละเอียด ${dataModalRoomDetail?.room_meeting_name}`}
                <Box className="flex items-start justify-start mt-2">
                  {/* Location */}
                  <Box className="flex items-center overflow-hidden">
                    <FmdGoodIcon className="mr-1" />
                    <Typography
                      variant="body2"
                      className="text-gray-500 truncate w-40"
                    >
                      {dataModalRoomDetail.room_meeting_location}
                    </Typography>
                  </Box>

                  {/* Meeting Amount */}
                  <Box className="flex items-center overflow-hidden">
                    <AccountCircleIcon className="mr-1" />
                    <Typography
                      variant="body2"
                      className="text-gray-500 truncate w-20"
                    >
                      {dataModalRoomDetail.room_meeting_amount} คน
                    </Typography>
                  </Box>
                </Box>

                <section className="flex items-center justify-center">
                  <ImageSlider
                    base_api_img={base_api_img}
                    room={
                      dataModalRoomDetail ?? {
                        files: [],
                      }
                    }
                  />
                </section>

                <h2 className="mt-6 mb-2 font-semibold">อุปกรณ์ภายในห้อง</h2>

                <div>
                  <ul className="list-disc pl-5 space-y-1">
                    {dataModalRoomDetail.equipment &&
                      dataModalRoomDetail.equipment.map(
                        (item: any, index: number) => (
                          <li key={`equipment-${item.id_equipment}`}>
                            {item.equipment_name}
                          </li>
                        )
                      )}
                  </ul>
                </div>
              </>
            </Grid>
          )}
        </Grid>
      </section>

      <section className="w-full mt-10">
        <Grid container spacing={2}>
          {roomMeeting.map((room: any, index: number) => (
            <Grid
              item
              xs={12}
              md={3}
              lg={3}
              key={room.id_room_meeting}
              sx={{ alignSelf: "end" }}
              onClick={() => {
                getRoomMeetingDetailById(+room.id_room_meeting);
              }}
            >
              <ClassroomCard
                room={room}
                setFormMeetingRoom={setFormMeetingRoom}
                formMeetingRoom={formMeetingRoom}
                setIsModalRoomDetail={setIsModalRoomDetail}
              />
            </Grid>
          ))}
        </Grid>
      </section>
    </section>
  );
}
